import React, { Component } from 'react';

import { BarChart, Bar, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

import Grid from '@material-ui/core/Grid';

import ChartMenu from './../ChartMenu/ChartMenu'
import CustomTooltip from './NegativeTooltip';
import './negativeStyle.css';

import { colors4 } from '../../../../constants/icons/characteristics/Characteristics';


class NegativeComponent extends Component {

  getData = () => {
    const { data } = this.props;
    let resp = [];
    for (let i = 0; i < 12; i++) {
      let temp = {
        index: i,
        name: i.toString() + ':00',
        am: data[i],
        pm: -data[i + 12]
      }
      resp.push(temp);
    }
    return resp;
  }

  getTotal = () => {
    const { data } = this.props;
    let resp = 0;
    for (let i = 0; i < data.length; i++) {
      resp += data[i];
    }
    return <p style={{ fontWeight: 'bold' }}>{'Total: ' + resp} </p>;
  }

  onClick = (uno, dos) => {
    try {
      this.props.onClickGraphic(this.props.name, { name: (uno.chartY <= 90) ? uno.activeTooltipIndex : uno.activeTooltipIndex + 12 });
    } catch (e) { }
  }


  render() {
    return (
      <Grid style={{ flexWrap: "inherit", margin: 'auto' }} id={this.props.name} >
        <ChartMenu graph={this.props.name} file={this.props.title}
          openDialog={this.props.openDialog} title={this.props.title} watch={this.props.watchMenu}
          seeMore={this.props.seeMore} />
        <Grid container>
          <Grid item xs={12}>
            <BarChart width={400} height={250} data={this.getData()} stackOffset="sign"
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              style={{ margin: 'auto' }} onClick={this.onClick}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" hide={true} />
              <YAxis fontSize={12} allowDecimals={false} />
              <Tooltip
                content={
                  <CustomTooltip
                    data={this.props.data}
                    colors={colors4}
                  />}
              />
              <Legend />
              <ReferenceLine y={0} stroke='#000' />
              <Bar dataKey="pm" fill={colors4[0]} stackId="stack" label={{ fontSize: 14 }} />
              <Bar dataKey="am" fill={colors4[1]} stackId="stack" label={{ fontSize: 14 }} />
            </BarChart>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default NegativeComponent;